import { Control, Controller } from "react-hook-form"
import { IDataCollectionStandardConfig } from "@piceasoft/core"
import { getCommonFieldRules } from "../../../helpers/validationRules"
import DateOfIssue from "./DateOfIssue"

import { TContractData } from "../../../../../dataCollectionTypes"

type TProps = {
    config?: IDataCollectionStandardConfig
    errorMessage: string
    phoneCountry?: string
    control: Control<TContractData, object>,
}

const DateOfIssueControlleer: React.FunctionComponent<TProps> = (props: TProps) => {
    const {
        config,
        control,
        errorMessage,
    } = props

    return (
        <Controller
            name="passport.dateOfIssue"
            control={control}
            rules={getCommonFieldRules(config?.fields?.passport?.dateOfIssue)}
            render={({ field }) =>
                <DateOfIssue
                    config={config}
                    value={field.value}
                    errorMessage={errorMessage}
                    handleOnBlur={field.onBlur}
                    handleOnChange={(value: string) => {
                        field.onChange(value)
                    }}
                />
            }
        />
    )
}

export default DateOfIssueControlleer